// src/app/layout/CoreLayout.tsx
import { useState } from 'react';
import { CoreSidebar } from './CoreSidebar';
import { CoreHeader } from './CoreHeader';
import { CoreWorkspace } from './CoreWorkspace';
import { CoreMobileNavDrawer } from './CoreMobileNavDrawer';

/**
 * Shell for every authenticated Super Admin screen:
 *
 *   CoreLayout
 *    ├── CoreSidebar     (desktop, >= lg)
 *    ├── CoreHeader
 *    └── CoreWorkspace   (Outlet)
 *
 * plus CoreMobileNavDrawer for < lg, mirroring CoreSidebar's nav.
 * Replaces Step 1's AppLayout — same responsibility (own the frame,
 * let pages own their own padding/scroll), renamed and split so the
 * Core* naming matches this phase's nav/header/badge components.
 * Rendered by AppRouter.tsx inside ProtectedSuperAdminRoute, so
 * everything under it is already known-authenticated + super_admin.
 */
export function CoreLayout() {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  return (
    <div dir="rtl" className="vania-command-shell vania-shell-layout">
      <CoreSidebar />
      <div className="vania-shell-main">
        <CoreHeader onOpenNav={() => setIsMobileNavOpen(true)} />
        <CoreWorkspace />
      </div>
      <CoreMobileNavDrawer isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} />
    </div>
  );
}
